<app-tabla
  [totalCount]="totalCount"
  [datos]="comandosHistorico"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [search]="search"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [filtros]="filtros"
  [emptyState]="{ title: 'Todavía no hay comandos' }"
></app-tabla>
